module.exports = __webpack_public_path__ + "static/media/DT-UK-2023.f249976f.png";